var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "pdfPopupNavbar"
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg")
    },
    on: {
      "click": _vm.hideClientNeedsGenerator
    }
  }), !_vm.generatingPdf ? _c('div', {
    staticClass: "w-button pointer",
    on: {
      "click": _vm.generate
    }
  }, [_vm._v(" GENEROVAŤ ")]) : _c('v-progress-circular', {
    attrs: {
      "size": "25",
      "width": "3",
      "indeterminate": "",
      "color": '#8c2a5e'
    }
  })], 1), !_vm.loading ? _c('div', {
    staticClass: "zopkbody",
    attrs: {
      "id": "generatedNeedsPart"
    }
  }, [_c('div', {
    staticClass: "page-wrapper"
  }, [_c('div', {
    staticClass: "container-zok w-container"
  }, [_c('div', {
    staticClass: "header2"
  }, [_c('div', {
    staticClass: "logo"
  }), _c('div', {
    staticClass: "subeheading limitwidth"
  }, [_vm._v("ZÁZNAM O POŽIADAVKÁCH A POTREBÁCH KLIENTA A O POSKYTNUTÍ INFORMÁCIÍ POTENCIÁLNEMU KLIENTOVI"), _c('br'), _vm._v("pre sektor Poskytovanie úverov, úverov na bývanie a spotrebiteľských úverov, "), _c('span', {
    staticClass: "ucel"
  }, [_vm._v(_vm._s(_vm.purposeLabel) + " ")]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(", klient p. " + _vm._s(_vm.$store.getters["mortgageDetailState/getApplicant"].last_name))])])]), _c('p', {
    staticClass: "paragraph"
  }, [_vm._v(" záznam o požiadavkách a potrebách klienta a o poskytnutí informácií potencionálnemu klientovi podľa § 32 ods. 2 až 4, § 33 a § 35 Zákona č. 186/2009 Z. z. o finančnom sprostredkovaní a finančnom poradenstve a o zmene a doplnení niektorých zákonov, v platnom znení ( ďalej len „zákon o finančnom sprostredkovaní”), o požiadavkách, potrebách, skúsenostiach, znalostiach a finančnej situácii neprofesionálneho klienta v súvislosti s finančnou službou, ktorá je predmetom finančného sprostredkovania a o poskytnutí informácií potenciálnemu klientovi a klientovi pred uzatvorením zmluvy o poskytnutí finančnej služby (ďalej len „záznam”). ")]), _vm._m(0), _vm._m(1), _c('p', {
    staticClass: "paragraph"
  }, [_vm._v(" slúži k ľahšiemu zorientovaniu sa v množstve ponúkaných produktov a služieb na finančnom trhu; jeho výsledkom je predloženie ponúk Klientovi Finančným agentom a následné uzatvorenie zmluvy s Finančnou inštitúciou, tzn. Finančný agent Vám odporučí a dá Vám na výber produkt, či službu podľa Vašich predstáv, potrieb a možností, zásadný rozdiel oproti finančnému poradenstvu spočíva v tom že služby Finančného agenta sú hradené finančnou inštitúciou; táto činnosť má právny základ v zákone č. 186/2009 Z. z. o finančnom sprostredkovaní a finančnom poradenstve a o zmene a doplnení niektorých zákonov, v platnom znení ")]), _vm._m(2), _c('p', {
    staticClass: "paragraph"
  }, [_vm._v("sú na účely tohto záznamu finančné inštitúcie, najmä tuzemské banky a pobočky zahraničných bánk")]), _vm._m(3), _c('p', {
    staticClass: "paragraph"
  }, [_vm._v(" je akákoľvek služba finančnej povahy, ktorú ponúka poskytovateľ finančnej služby, v tomto prípade Finančná inštitúcia, pričom na účely záznamu ide o tieto Finančné služby - pôžičky všetkých druhov vrátane spotrebných úverov, hypotekárnych úverov ")]), _vm._m(4), _c('p', {
    staticClass: "paragraph"
  }, [_vm._v(" PFA ako užívateľ aplikácie bankari.sk zároveň vykonáva finančné sprostredkovanie aj prostredníctvom / pomocou portálu bankari.sk respektíve jeho subdomény app.bankari.sk. Aplikácia bankari.sk pred uzatvorením zmluvy o poskytnutí Finančnej služby zaznamenáva požiadavky a potreby klienta, súvisiace s dojednávanou Finančnou službou a dôvody, na základe ktorých PFA poskytuje svoje odporúčanie pre výber tej ktorej Finančnej služby, a to v písomnej podobe alebo v elektronickej podobe na internetovej stránke www.bankari.sk / "), _c('a', {
    attrs: {
      "href": "http://www.app.bankari.sk"
    }
  }, [_vm._v("www.app.bankari.sk")]), _vm._v(" prostredníctvom na to určených častí formulára a kalkulačiek, formulárov zmlúv, alebo prostredníctvom e-mailu a to v zmysle súhlasu s elektronickou komunikáciou udelenou Klientom "), _c('strong', [_vm._v(" " + _vm._s(_vm.getConvertedDate(_vm.applicant.clientObject.client_profile.created)) + " ")]), _vm._v("PFA ")]), _vm._m(5), _vm._m(6), _c('p', {
    staticClass: "paragraph"
  }, [_vm._v(" Finančným agentom vykonávajúcim finančné sprostredkovanie je spoločnosť " + _vm._s(_vm.staffProfil.staff_profile.sfa.obchodne_meno) + ". so sídlom " + _vm._s(_vm.staffProfil.staff_profile.sfa.adresa) + ", IČO: " + _vm._s(_vm.staffProfil.staff_profile.sfa.ico) + " ako samostatný finančný agent, zapísaný v registri NBS pod registračným číslom "), _c('strong', [_vm._v(_vm._s(_vm.staffProfil.staff_profile.sfa.reg_cislo))]), _vm._v(" v podregistroch poistenia a zaistenia, kapitálového trhu, prijímania vkladov, poskytovania úverov, úverov na bývanie a spotrebiteľských úverov, doplnkového dôchodkového sporenia a starobného dôchodkového sporenia ("), _c('em', [_vm._v("ďalej aj ako „Samostatný finančný agent“ alebo „SFA“")]), _vm._v("), alebo podriadený finančný agent vykonávajúceho finančné sprostredkovanie na základe písomnej zmluvy so spoločnosťou " + _vm._s(_vm.staffProfil.staff_profile.sfa.obchodne_meno) + ", a to " + _vm._s(_vm.staffProfil.staff_profile.obchodne_meno) + " so sídlom " + _vm._s(_vm.staffProfil.staff_profile.adresa) + ", IČO: " + _vm._s(_vm.staffProfil.staff_profile.ico) + ", zapísaný v registri NBS v zozname podriadených finančných agentov v sektore poskytovania úverov, úverov na bývanie spotrebiteľských úverov s registračným číslom "), _c('strong', [_vm._v(_vm._s(_vm.staffProfil.staff_profile.cislo_registracie_NBS) + " ")]), _vm._v("("), _c('em', [_vm._v("ďalej aj ako „Podriadený Finančný agent“ alebo PFA")]), _vm._v("), KONTAKT (" + _vm._s(_vm.staffProfil.staff_profile.email) + ", " + _vm._s(_vm.staffProfil.staff_profile.telephone) + "). Podľa zoznamu finančných agentov vedeného NBS (zápis PFA / SFA / v registri NBS je možné overiť na internetovej adrese: "), _c('a', {
    attrs: {
      "href": "http://regfap.nbs.sk/search.php"
    }
  }, [_vm._v("http://regfap.nbs.sk/search.php")]), _vm._v(")")]), _vm._m(7), _c('p', {
    staticClass: "paragraph"
  }, [_vm._v(" Fyzická osoba: "), _c('span', {
    staticClass: "dynamic-data-block",
    attrs: {
      "id": "ziadatel_data"
    }
  }, [_vm._v(" " + _vm._s(_vm._f("addComma")(_vm.applicant.clientObject.degree)) + " " + _vm._s(_vm.applicant.clientObject.first_name) + " " + _vm._s(_vm._f("addComma")(_vm.applicant.clientObject.last_name)) + " adresa: " + _vm._s(_vm.applicant.clientObject.client_profile.permanent_address_street) + " " + _vm._s(_vm._f("addComma")(_vm.applicant.clientObject.client_profile.permanent_address_number)) + " " + _vm._s(_vm.applicant.clientObject.client_profile.permanent_address_zip) + " " + _vm._s(_vm._f("addComma")(_vm.applicant.clientObject.client_profile.permanent_address_city)) + " príslušnosť: " + _vm._s(_vm._f("addComma")(_vm.applicant.clientObject.client_profile.statna_prislusnost)) + " rodné číslo: " + _vm._s(_vm._f("addComma")(_vm.applicant.clientObject.client_profile.rodne_cislo)) + " číslo dokladu totožnosti: " + _vm._s(_vm._f("addComma")(_vm.applicant.clientObject.client_profile.op_cislo)) + " rodinný stav: " + _vm._s(_vm._f("addComma")(_vm.translateFromDbValue('clientProfileForm', 'rodinny_stav', _vm.applicant.clientObject.client_profile.rodinny_stav))) + " kontakt: (+421) " + _vm._s(_vm._f("addComma")(_vm.applicant.clientObject.client_profile.telephone)) + " " + _vm._s(_vm.applicant.clientObject.email) + " ")]), _vm._v(" pričom PFA vyhlasuje, že overil totožnosť a identifikoval klienta v rozsahu potrebnom na uzatvorenie zmluvy o poskytovaní finančnej služby v zmysle zákona o finančnom sprostredkovaní a č. 186/2009 Z.z. a zákona č. 297/2008 Z.z. o ochrane pred legalizáciou príjmov z trestnej činnosti a o ochrane pred financovaním terorizmu a o zmene a doplnení niektorých zákonov. Klient vyhlasuje že nemá pracovné a ani iné profesionálne skúsenosti s finančným trhom, pre vylúčenie pochybností to znamená, že požaduje aby sa s ním zaobchádzalo ako s neprofesionálnym klientom. "), _c('br')]), _vm.coApplicant.clientObject ? _c('div', [_vm._m(8), _c('p', {
    staticClass: "paragraph"
  }, [_vm._v(" Fyzická osoba: "), _c('span', {
    staticClass: "dynamic-data-block",
    attrs: {
      "id": "ziadatel_data"
    }
  }, [_vm._v(" " + _vm._s(_vm._f("addComma")(_vm.coApplicant.clientObject.degree)) + " " + _vm._s(_vm.coApplicant.clientObject.first_name) + " " + _vm._s(_vm._f("addComma")(_vm.coApplicant.clientObject.last_name)) + " adresa: " + _vm._s(_vm.coApplicant.clientObject.client_profile.permanent_address_street) + " " + _vm._s(_vm._f("addComma")(_vm.coApplicant.clientObject.client_profile.permanent_address_number)) + " " + _vm._s(_vm._f("addComma")(_vm.coApplicant.clientObject.client_profile.permanent_address_zip)) + " " + _vm._s(_vm._f("addComma")(_vm.coApplicant.clientObject.client_profile.permanent_address_city)) + " príslušnosť: " + _vm._s(_vm._f("addComma")(_vm.coApplicant.clientObject.client_profile.statna_prislusnost)) + " rodné číslo: " + _vm._s(_vm._f("addComma")(_vm.coApplicant.clientObject.client_profile.rodne_cislo)) + " číslo dokladu totožnosti: " + _vm._s(_vm._f("addComma")(_vm.coApplicant.clientObject.client_profile.op_cislo)) + " rodinný stav: " + _vm._s(_vm._f("addComma")(_vm.translateFromDbValue('clientProfileForm', 'rodinny_stav', _vm.coApplicant.clientObject.client_profile.rodinny_stav))) + " kontakt: (+421) " + _vm._s(_vm._f("addComma")(_vm.coApplicant.clientObject.client_profile.telephone)) + " " + _vm._s(_vm.coApplicant.clientObject.email) + " ")]), _vm._v(" a ktorý zároveň zdieľa s Klientom domácnosť alebo je rodinným príslušníkom. Klient a Spoluklient ďalej spoločne aj ako \"Klient\". "), _c('br')])]) : _vm._e(), _vm._m(9), _vm._m(10), _c('p', {
    staticClass: "paragraph"
  }, [_vm._v(" Klient požiadal PFA o sprostredkovanie Finančnej služby za účelom financovania nasledovných potrieb klienta: ")]), _vm.pickClientOrBrokerAmount('suma_nadobudnutie') !== 0 ? _c('div', {
    staticClass: "w-layout-grid-c grid-ii-columns"
  }, [_vm._m(11), _vm._m(12), _c('div', {
    staticClass: "content-block"
  }, [_c('div', [_vm._v(" Nadobudnutie " + _vm._s(_vm.sumAmounts(_vm.pickClientOrBrokerAmount('all'))) + " EUR ")])]), _c('div', {
    staticClass: "content-block"
  }, [_c('div', [_vm._v(_vm._s(_vm.sumPropertiesValues('foundedProperties')) + " EUR")])])]) : _vm._e(), _vm.pickClientOrBrokerAmount('suma_refinancovanie') !== 0 ? _c('div', {
    staticClass: "w-layout-grid-c grid-iv-columns"
  }, [_vm._m(13), _vm._m(14), _vm._m(15), _vm._m(16), _c('div', {
    staticClass: "content-block"
  }, [_c('div', [_vm._v(" Refinancovanie + " + _vm._s(_vm.sumAmounts(_vm.pickClientOrBrokerAmount('all'))) + " EUR ")])]), _c('div', {
    staticClass: "content-block"
  }, [_c('div', [_vm._v(_vm._s(_vm.sumPropertiesValues('foundedProperties')) + " EUR")])]), _c('div', {
    staticClass: "content-block"
  }, [_c('div', [_vm._v(_vm._s(_vm.mortgage.ltv.value * 100) + "%")])]), _c('div', {
    staticClass: "content-block"
  }, [_c('div', [_vm._v(_vm._s(_vm.pickClientOrBrokerAmount('suma_refinancovanie')) + " EUR")])])]) : _vm._e(), _vm.pickClientOrBrokerAmount('suma_bezucel') !== 0 ? _c('div', {
    staticClass: "w-layout-grid-c grid-iv-columns"
  }, [_vm._m(17), _vm._m(18), _vm._m(19), _vm._m(20), _c('div', {
    staticClass: "content-block"
  }, [_c('div', [_vm._v(" Bezúčelový úver + " + _vm._s(_vm.sumAmounts(_vm.pickClientOrBrokerAmount('all'))) + " EUR ")])]), _c('div', {
    staticClass: "content-block"
  }, [_c('div', [_vm._v(_vm._s(_vm.sumPropertiesValues('foundedProperties')) + " EUR")])]), _c('div', {
    staticClass: "content-block"
  }, [_c('div', [_vm._v(_vm._s(_vm.mortgage.ltv.value * 100) + "%")])]), _c('div', {
    staticClass: "content-block"
  }, [_c('div', [_vm._v(_vm._s(_vm.pickClientOrBrokerAmount('suma_bezucel')) + " EUR")])])]) : _vm._e(), _c('p', {
    staticClass: "paragraph marginTop"
  }, [_vm._v("Požiadavky na parametre Finančnej služby na naplnenie hore uvedenej potreby sú: ")]), _c('div', {
    staticClass: "w-layout-grid-c grid-iv-columns"
  }, [_vm._m(21), _vm._m(22), _vm._m(23), _vm._m(24), _c('div', {
    staticClass: "content-block"
  }, [_c('div', [_vm._v(_vm._s(_vm.getMaxFromApplications('splatnost')) + " rokov")])]), _c('div', {
    staticClass: "content-block"
  }, [_c('div', [_vm._v(_vm._s(_vm.getMaxFromApplications('fix')) + " rokov")])]), _c('div', {
    staticClass: "content-block"
  }, [_c('div', [_vm._v(_vm._s(_vm._f("ceil")(_vm.getMaxFromApplications('splatka') * 1.1)) + " EUR")])]), _c('div', {
    staticClass: "content-block"
  }, _vm._l(_vm.prefferedBanks, function (bank, index) {
    return _c('div', {
      key: index
    }, [_vm._v(" " + _vm._s(bank) + ", ")]);
  }), 0)]), _vm._m(25), _vm._m(26), _vm._l(_vm.filterActive(_vm.applicant.incomes), function (income, index) {
    var _income$dti$extra;
    return _c('div', {
      key: index + 'appinc',
      staticClass: "w-layout-grid-c grid-iv-columns"
    }, [_c('div', {
      staticClass: "content-block"
    }, [_c('div', [_vm._v(_vm._s(index + 1) + ". " + _vm._s(_vm.translateFromDbValue('incomeForm', 'druh', income.druh)) + " ")])]), _c('div', {
      staticClass: "content-block"
    }, [['prijem_zivnostnika', 'prijem_z_sro'].includes(income.druh) ? _c('div', [_vm._v(" " + _vm._s(income.zamestnavatel_odvetvie))]) : _c('div', [_vm._v(" " + _vm._s(_vm.$store.getters['formStore/getProfessionLabelById'](income.profesia)))])]), _c('div', {
      staticClass: "content-block"
    }, [_c('div', [_vm._v(" " + _vm._s(_vm._f("ceil")((_income$dti$extra = income.dti.extra) === null || _income$dti$extra === void 0 ? void 0 : _income$dti$extra.prijem_mo)) + " EUR")])]), _c('div', {
      staticClass: "content-block"
    }, [_c('div', [_vm._v("+ " + _vm._s(_vm._f("ceil")(_vm.getDstiCalculation(_vm.filterActive(_vm.applicant.incomes), index))) + " EUR")])])]);
  }), _vm._l(_vm.filterActive(_vm.applicant.incomes), function (income, index) {
    return _c('p', {
      key: index + 'appincinf',
      staticClass: "paragraph marginTop"
    }, [_vm._v(" " + _vm._s(_vm.getInformationAboutIncome(income, index)) + " ")]);
  }), _vm.coApplicant.clientObject ? _c('div', [_vm._m(27), _vm._m(28), _vm._l(_vm.filterActive(_vm.coApplicant.incomes), function (income, index) {
    var _income$dti$extra2;
    return _c('div', {
      key: index + 'coappinc',
      staticClass: "w-layout-grid-c grid-iv-columns"
    }, [_c('div', {
      staticClass: "content-block"
    }, [_c('div', [_vm._v(_vm._s(index + 1) + ". " + _vm._s(_vm.translateFromDbValue('incomeForm', 'druh', income.druh)))])]), _c('div', {
      staticClass: "content-block"
    }, [['prijem_zivnostnika', 'prijem_z_sro'].includes(income.druh) ? _c('div', [_vm._v(" " + _vm._s(income.zamestnavatel_odvetvie))]) : _c('div', [_vm._v(" " + _vm._s(_vm.$store.getters['formStore/getProfessionLabelById'](income.profesia)))])]), _c('div', {
      staticClass: "content-block"
    }, [_c('div', [_vm._v(" " + _vm._s(_vm._f("ceil")((_income$dti$extra2 = income.dti.extra) === null || _income$dti$extra2 === void 0 ? void 0 : _income$dti$extra2.prijem_mo)) + " EUR")])]), _c('div', {
      staticClass: "content-block"
    }, [_c('div', [_vm._v("+ " + _vm._s(_vm._f("ceil")(_vm.getDstiCalculation(_vm.filterActive(_vm.coApplicant.incomes), index))) + " EUR")])])]);
  }), _vm._l(_vm.filterActive(_vm.coApplicant.incomes), function (income, index) {
    return _c('p', {
      key: index + 'coappincinf',
      staticClass: "paragraph marginTop"
    }, [_vm._v(" " + _vm._s(_vm.getInformationAboutIncome(income, index)) + " ")]);
  })], 2) : _vm._e(), _vm._m(29), _vm.doesClientHaveDebts(_vm.applicant) ? _c('div', {
    staticClass: "w-layout-grid-c grid-iii-columns"
  }, [_vm._m(30), _vm._m(31), _vm._m(32)]) : _c('p', {
    staticClass: "paragraph"
  }, [_vm._v(" Klient nemá žiadne výdavky úverového typu od bankovej či nebankovej inštitúcie. ")]), _vm._l(_vm.filterVisible(_vm.applicant.debts), function (debt, index) {
    return _c('div', {
      key: index + 'appdeb',
      staticClass: "w-layout-grid-c grid-iii-columns"
    }, [_c('div', {
      staticClass: "content-block"
    }, [_c('div', [_vm._v(_vm._s(index + 1) + ". " + _vm._s(_vm.translateFromDbValue('debtForm', 'typ', debt.typ)) + " - " + _vm._s(_vm.translateBank(debt.banka)) + " ")])]), _c('div', {
      staticClass: "content-block"
    }, [_c('div', [_vm._v(" " + _vm._s(_vm._f("ceil")(debt.vyska_splatky)) + " EUR")])]), _c('div', {
      staticClass: "content-block"
    }, [_c('div', [_vm._v(" " + _vm._s(debt.zostatok ? debt.zostatok + " EUR" : ""))])])]);
  }), _vm.coApplicant.clientObject ? _c('div', [_vm._m(33), _vm.doesClientHaveDebts(_vm.coApplicant) ? _c('div', {
    staticClass: "w-layout-grid-c grid-iii-columns"
  }, [_vm._m(34), _vm._m(35), _vm._m(36)]) : _c('p', {
    staticClass: "paragraph"
  }, [_vm._v(" Klient nemá žiadne výdavky úverového typu od bankovej či nebankovej inštitúcie. ")]), _vm._l(_vm.filterVisible(_vm.coApplicant.debts), function (debt, index) {
    return _c('div', {
      key: index + 'coappdeb',
      staticClass: "w-layout-grid-c grid-iii-columns"
    }, [_c('div', {
      staticClass: "content-block"
    }, [_c('div', [_vm._v(_vm._s(index + 1) + ". " + _vm._s(_vm.translateFromDbValue('debtForm', 'typ', debt.typ)) + " - " + _vm._s(_vm.translateBank(debt.banka)) + " ")])]), _c('div', {
      staticClass: "content-block"
    }, [_c('div', [_vm._v(" " + _vm._s(_vm._f("ceil")(debt.vyska_splatky * 1.1)) + " EUR")])]), _c('div', {
      staticClass: "content-block"
    }, [_c('div', [_vm._v(" " + _vm._s(debt.zostatok ? debt.zostatok : "") + " EUR")])])]);
  })], 2) : _vm._e(), _vm._m(37), _c('div', {
    staticClass: "w-layout-grid-c grid-iv-columns"
  }, [_vm._m(38), _vm._m(39), _vm._m(40), _vm._m(41), _c('div', {
    staticClass: "content-block"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.translateFromDbValue('clientProfileForm', 'rodinny_stav', _vm.applicant.clientObject.client_profile.rodinny_stav)) + " ")])]), _c('div', {
    staticClass: "content-block"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.applicant.clientObject.client_profile.pocet_nezaopatrenych_deti) + " ")])]), _c('div', {
    staticClass: "content-block"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.translateFromDbValue('clientProfileForm', 'vzdelanie', _vm.applicant.clientObject.client_profile.vzdelanie)) + " ")])]), _c('div', {
    staticClass: "content-block"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.getAge(_vm.applicant.clientObject.client_profile.datum_narodenia)) + " ")])])]), _vm.coApplicant.clientObject ? _c('div', {
    staticClass: "w-layout-grid-c grid-iv-columns",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._m(42), _vm._m(43), _vm._m(44), _vm._m(45), _c('div', {
    staticClass: "content-block"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.translateFromDbValue('clientProfileForm', 'rodinny_stav', _vm.coApplicant.clientObject.client_profile.rodinny_stav)) + " ")])]), _c('div', {
    staticClass: "content-block"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.coApplicant.clientObject.client_profile.pocet_nezaopatrenych_deti) + " ")])]), _c('div', {
    staticClass: "content-block"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.translateFromDbValue('clientProfileForm', 'vzdelanie', _vm.coApplicant.clientObject.client_profile.vzdelanie)) + " ")])]), _c('div', {
    staticClass: "content-block"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.getAge(_vm.coApplicant.clientObject.client_profile.datum_narodenia)) + " ")])])]) : _vm._e(), _vm.coApplicant.clientObject ? _c('p', {
    staticClass: "paragraph marginTop"
  }, [_vm._v(" *z toho spoločných detí: "), _c('strong', [_vm._v(" " + _vm._s(_vm.mortgage.pocet_spolocnych_nezaopatrenych_deti) + " ")])]) : _vm._e(), _vm._m(46), _c('p', {
    staticClass: "paragraph"
  }, [_vm._v(" S ohľadom na informácie poskytnuté Klientom v tomto zázname poskytuje Finančný agent klientovi označené informácie, odporúčania a odbornú pomoc v súvislosti s výberom vhodnej Finančnej služby. Finančný agent odporúča uzatvorenie zmluvy (zmlúv) o poskytnutí Finančnej služby v sektore poskytovania úverov nasledovne: ")]), _c('div', {
    staticClass: "offer-list"
  }, [_vm._m(47), _vm._l(_vm.mortgage.applications, function (application, index) {
    return application.stage !== 'zrusena' ? _c('div', {
      key: index + 'applic',
      staticClass: "mortgage-result-broker zok"
    }, [_c('div', {
      staticClass: "mortgage-parameters zok"
    }, [_c('div', {
      staticClass: "banklogowrapper"
    }, [_c('img', {
      staticClass: "bank-logo",
      attrs: {
        "src": application.bank.logo_square,
        "loading": "lazy",
        "alt": application.bank.nazov
      }
    }), _vm._v(_vm._s(application.bank.nazov) + " ")]), _c('div', {
      staticClass: "bold-2 wrap100px green"
    }, [_vm._v(" " + _vm._s(_vm._f("dotTheAmount")(_vm.getTotalAmount(application))) + " € ")]), _c('div', {
      staticClass: "bold-2 wrap100px"
    }, [_vm._v(" " + _vm._s(application.sadzba_pozadovana) + " % ")]), _c('div', {
      staticClass: "bold-2 wrap100px green"
    }, [_vm._v(" " + _vm._s(_vm._f("toFloor")(application.splatka, 2)) + " € ")]), _c('div', {
      staticClass: "bold-2 wrap100px"
    }, [_vm._v(" " + _vm._s(_vm._f("ceil")(application.poplatok_za_poskytnutie ? application.poplatok_za_poskytnutie : 0)) + " € ")]), _c('div', {
      staticClass: "bold-2"
    }, [_vm._v(" " + _vm._s(application.splatnost) + " R ")]), _c('div', {
      staticClass: "bold-2 wrap100px"
    }, [_vm._v(" " + _vm._s(_vm._f("ceil")(application.popl_za_vedenie_uctu)) + " €/m ")]), _c('div', {
      staticClass: "bold-2 wrap50px"
    }, [_vm._v(" " + _vm._s(application.fix) + " R ")]), _c('div', {
      staticClass: "bold-2 wrap100px"
    }, [_vm._v(" " + _vm._s(_vm._f("ceil")(application.preplatenost)) + " € ")])]), _c('div', {
      staticClass: "discount-list"
    })]) : _vm._e();
  })], 2), _c('p', {
    staticClass: "paragraph"
  }, [_vm._v(" Zmluvy o poskytnutí Finančnej služby v sektore poskytovania úverov označené ako \"vybraná\" boli vybrané Klientom. Finančný agent prehlasuje, že vybrané zmluvy pre klienta sú vhodné lebo zodpovedajú potrebe a požiadavkám na zmluvu o Finančnej službe v zmysle bodu 2. tohto záznamu. ")]), _vm._m(48), _vm._m(49), _vm._m(50), _vm._m(51), _c('p', {
    staticClass: "paragraph"
  }, [_vm._v(" Klient si je vedomý, že tento záznam nie je návrhom na uzavretie zmluvy o poskytnutí Finančnej služby. Uzavretím zmluvy o Finančnej službe vznikajú Klientovi a Finančnej inštitúcii práva a povinnosti uvedené v zmluve o Finančnej službe a v príslušných súvisiacich všeobecných a osobitných podmienkach alebo obchodných podmienkach, ktoré tvoria neoddeliteľnú súčasť zmluvy o Finančnej službe. Ide najmä o práva a povinnosti zmluvných strán (najmä, nie však výlučne Klienta a Finančnej inštitúcie) súvisiace s finančným plnením, ktoré závisia od dohodnutého predmetu a obsahu zmluvy o Finančnej službe. Dohodnuté práva a povinnosti zmluvných strán ako aj ďalšie zmluvné podmienky je možné meniť len spôsobom a postupom dohodnutým v zmluve o Finančnej službe alebo na základe ďalšej dohody zmluvných strán. Predčasné ukončenie takejto zmluvy alebo porušenie dohodnutých zmluvných podmienok a povinností niektorou zo zmluvných strán, môže mať za následok, že si dotknutá zmluvná strana uplatní zmluvne dohodnutú sankciu za ich porušenie a/alebo že si dotknutá zmluvná strana uplatní zmluvne alebo všeobecne záväzným právnym predpisom stanovený nárok na náhradu škody a/alebo nárok na úrok z omeškania. Ak klient poruší pravidlá a postupy dohodnuté pred podpisom zmluvy o Finančnej službe, o ktorých bol vopred informovaný Finančnou inštitúciou alebo Finančným agentom a s ktorými vyslovil pred podpisom samotnej zmluvy súhlas, môže dôjsť aj k nenaplneniu očakávaných finančných cieľov a zámerov, kvôli ktorým bola zmluva uzavretá. ")]), _vm._m(52), _c('p', {
    staticClass: "paragraph"
  }, [_vm._v(" V prípade ak Klient, t. j. dlžník/spoludlžník alebo ručiteľ bude v omeškaní so splátkou, môže dôjsť k mimoriadnej splatnosti zmluvy o Finančnej službe - úveru/pôžičky; nesplácanie úveru/pôžičky načas môže mať za následok zápis do úverového registra, následne môže mať Klient v budúcnosti problém pri žiadaní o následný úver/pôžičku; v prípade ak Klient si nebude načas plniť svoje záväzky plynúce z uzatvorenej zmluvy o Finančnej službe, t. j. úvere / pôžičke, prechádzajú tieto záväzky na ručiteľa; predčasné splatenie celého úveru / jeho časti, môže byť spoplatnené (podľa sadzobníka) Finančnej inštitúcie. ")]), _vm._m(53), _vm._m(54), _vm._m(55), _c('p', {
    staticClass: "paragraph"
  }, [_vm._v(" Klient potvrdzuje, že mu boli poskytnuté informácie o tom, že SFA a PFA ako prevádzkovateľ, spracúvajú osobné údaje uvedené v tomto Zázname na účely vykonávania finančného sprostredkovania, v rozsahu a za podmienok stanovených zákonom, a to najmä zákonom o FS a v súlade s nariadením Európskeho parlamentu a Rady (EÚ) 2016/679 o ochrane fyzických osôb pri spracúvaní osobných údajov a o voľnom pohybe takýchto údajov, ktorým sa zrušuje smernica 95/46/ES, čo je nevyhnutné na splnenie zákonnej povinnosť SFA a PFA. Osobné údaje sú uchovávané po dobu najmenej desiatich rokov od začiatku platnosti zmluvy o poskytnutí Finančnej služby.Práva dotknutej osoby: právo požadovať prístup k osobným údajom, ktoré sa týkajú Klienta, právo na opravu osobných údajov, právo na vymazanie a/alebo obmedzenie spracúvania osobných údajov, právo na prenositeľnosť osobných údajov, právo podať sťažnosť na spracúvanie osobných údajov orgánu dozoru – Úradu na ochranu osobných údajov Slovenskej republiky. Podrobné informácie o spracúvaní osobných údajov sú uvedené v Informáciách o ochrane osobných údajov, ktoré sú zverejnené aj na webovej Stránke SFA. ")]), _vm._m(56), _c('p', {
    staticClass: "paragraph"
  }, [_vm._v(" Systém ochrany pred zlyhaním finančnej inštitúcie je zabezpečený prostredníctvom dohľadu NBS a iných súvisiacich mechanizmov. Cieľom dohľadu nad finančným trhom je prispievať k stabilite finančného trhu ako celku, ako aj k bezpečnému a zdravému fungovaniu finančného trhu, ochrany klientov a rešpektovania pravidiel hospodárskej súťaže. Takto rizikovo orientovaný dohľad zameraný na analýzu a vyhodnocovanie kvantitatívnych ukazovateľov dohliadaných subjektov, medzi ktoré napr. patrí splnenie kapitálových požiadaviek, vyššia kvalita ohodnocovania rizík, efektívna alokácia kapitálu, je vykonávaný nad bankovníctvom, platobnými inštitúciami, inštitúciami elektronických peňazí, trhom cenných papierov, poisťovníctvom, dôchodkovým sporením, finančným sprostredkovaním a finančným poradenstvom. Funkčnými mechanizmami ochrany pred zlyhaním finančnej inštitúcie sú Fond na ochranu vkladov zriadený zákonom č.118/1996 Z.z. o ochrane vkladov v planom znení a Garančný fond investícií zriadený zákonom č.566/2001 Z.z. o cenných papieroch a investičných službách v platnom znení, ktoré poskytujú náhrady za nedostupné klientske vklady a majetok. ")]), _vm._m(57), _c('p', {
    staticClass: "paragraph"
  }, [_vm._v(" Sťažnosť na činnosť SFA alebo PFA môže Klient podať osobne, prostredníctvom pošty alebo kuriérnej služby priamo v sídle spoločnosti SFA ale PFA, alebo prostredníctvom elektronickej pošty na adresu SFA alebo PFA uvedenú v záhlaví tohto záznamu. Pre SFA a PFA vyplýva zmluvná povinnosť vzájomného informovania sa o skutočnosti, že bola podaná sťažnosť v zmysle tohto odstavca. Lehota na vybavenie sťažnosti je 30 dní odo dňa doručenia sťažnosti. V prípadoch sťažností náročných na prešetrenie môže spoločnosť SFA alebo PFA predĺžiť lehotu na jej vybavenie o ďalších 30 dní. O každom predĺžení lehoty na vybavenie a dôvodoch predĺženia je Finančný agent povinný písomne upovedomiť Klienta. Osobitnými predpismi upravujúcimi mimosúdne vyrovnanie sporov vyplývajúcich z Finančného sprostredkovania sa rozumejú zákon č. 244/2002 Z.z. o rozhodcovskom konaní v znení zákona č. 521/2005 Z.z. a zákon č. 420/2004 Z.z. o mediácii a o doplnení niektorých zákonov, zákon č. 335/2014 Z.z. o spotrebiteľskom rozhodcovskom konaní a zákon č. 391/2015 Z.z. o alternatívnom riešení sporov. Klient sa môže obrátiť na orgán alternatívneho riešenia sporov v sektore poistenia alebo zaistenia, a to najmä na poisťovacieho ombudsmana zriadeného pri Slovenskej asociácii poisťovní (SLASPO). ")]), _vm._m(58), _vm._m(59), _vm._m(60), _vm._m(61), _vm._m(62), _vm._m(63), _c('div', {
    staticClass: "w-layout-grid-c grid-podpisy"
  }, [_c('div', {
    staticClass: "signature-block"
  }, [_c('div', [_vm._v("V Bratislava dňa " + _vm._s(_vm.getConvertedDate(_vm.applicant.clientObject.client_profile.created)))]), _c('div', {
    attrs: {
      "id": "podpis_ziadate"
    }
  }, [_vm._v("za Klienta "), _c('strong', [_vm._v(_vm._s(_vm.applicant.clientObject.first_name) + " " + _vm._s(_vm.applicant.clientObject.last_name))])])]), _vm.coApplicant.clientObject ? _c('div', {
    staticClass: "signature-block"
  }, [_c('div', [_vm._v("V Bratislava dňa " + _vm._s(_vm.getConvertedDate(_vm.applicant.clientObject.client_profile.created)))]), _c('div', {
    attrs: {
      "id": "podpis_spoluziadate"
    }
  }, [_vm._v("za Spoluklienta "), _c('strong', [_vm._v(_vm._s(_vm.coApplicant.clientObject.first_name) + " " + _vm._s(_vm.coApplicant.clientObject.last_name))])])]) : _vm._e(), _c('div', {
    staticClass: "signature-block"
  }, [_c('div', [_vm._v("V Bratislava dňa " + _vm._s(_vm.getConvertedDate(_vm.applicant.clientObject.client_profile.created)))]), _c('div', {
    attrs: {
      "id": "broker"
    }
  }, [_vm._v("za PFA "), _c('strong', [_vm._v(_vm._s(_vm.broker.first_name) + " " + _vm._s(_vm.broker.last_name))])])])])], 2)])]) : _vm._e()]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-divider"
  }, [_c('div', [_vm._v("1. Vysvetlenie pojmov")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "subheading"
  }, [_c('strong', [_vm._v("Finančné sprostredkovanie")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "subheading"
  }, [_c('strong', [_vm._v("Finančná inštitúcia")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "subheading"
  }, [_c('strong', [_vm._v("Finančná služba")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "subheading"
  }, [_c('strong', [_vm._v("Aplikácia bankari.sk")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-divider"
  }, [_c('div', [_vm._v(" 2. Identifikácia Finančného agenta a Klienta ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "subheading"
  }, [_c('strong', [_vm._v("Finančný agent")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "subheading"
  }, [_c('strong', [_vm._v("Klient")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "subheading"
  }, [_c('strong', [_vm._v("Spoluklient")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "paragraph"
  }, [_vm._v("Klient zároveň svojím podpisom na tomto zázname vyhlasuje a potvrdzuje že:"), _c('br'), _vm._v("‍"), _c('br'), _vm._v("- koná vo vlastnom mene,"), _c('br'), _vm._v("- nie je politický exponovaná osoba,"), _c('br'), _vm._v("- má záujem o uzatvorenie zmluvy o Finančnej službe,"), _c('br'), _vm._v("- vykonáva tento obchod na vlastný účet,"), _c('br'), _vm._v("- finančné prostriedky použité pri tomto obchode sú vlastníctvom Klienta,"), _c('br'), _vm._v("- finančné prostriedky použité pri tomto obchode pochádzajú z vlastných zdrojov Klienta,"), _c('br'), _vm._v("- je konečným užívateľom výhod Finančnej služby,"), _c('br'), _vm._v("- nie je daňový rezident USA. ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-divider"
  }, [_c('div', [_vm._v("3. Potreby a požiadavky Klienta")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("Účel hypotéky")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("hodnota založených nehn.")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("Účel hypotéky")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("hodnota založených nehn.")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("LTV")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("zostatok refinancovaných"), _c('br'), _vm._v("a konsolidovaných úverov ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("Účel hypotéky")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("hodnota založených nehn.")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("LTV")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("požadovaná suma bezúčelovej hypotéky")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("Splatnosť")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("Fixácia")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("Max. výška splátky")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("Preferovaná banka")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-divider"
  }, [_c('div', [_vm._v("4. Identifikácia situácie Klienta (príjmy)")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-layout-grid-c grid-iv-columns"
  }, [_c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("Príjmy")])]), _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("profesia/odvetvie")])]), _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("čistý mesačný príjem")])]), _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("dopad na DSTI")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-divider"
  }, [_c('div', [_vm._v("Identifikácia situácie Spoluklienta (príjmy)")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-layout-grid-c grid-iv-columns"
  }, [_c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("Príjmy")])]), _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("profesia/odvetvie")])]), _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("čistý mesačný príjem")])]), _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("dopad na DSTI")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-divider"
  }, [_c('div', [_vm._v("5. Identifikácia situácie Klienta (existujúce úvery a výdavky)")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("Výdavky Klienta")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("splátka")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("zostatok")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-divider"
  }, [_c('div', [_vm._v("Identifikácia situácie Spoluklienta (existujúce úvery a výdavky)")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("Výdavky Klienta")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("splátka")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("zostatok")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-divider"
  }, [_c('div', [_vm._v("6. Identifikácia situácie Klienta (rodinný stav)")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("rodinný stav Klienta")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("počet detí")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("najvyš. vzdelanie")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("vek")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("rodinný stav Spoluklienta")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("počet detí")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("najvyš. vzdelanie")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "legend-block"
  }, [_c('div', [_vm._v("vek")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-divider"
  }, [_c('div', [_vm._v("7. Odporúčané riešenia")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "results-legend zok"
  }, [_c('div', {
    staticClass: "break-40px"
  }), _c('p', [_vm._v("výška")]), _c('p', [_vm._v("sadzba")]), _c('p', [_vm._v("splátka")]), _c('p', [_vm._v("poplatok")]), _c('p', [_vm._v("splatnosť")]), _c('p', [_vm._v("účet")]), _c('p', [_vm._v("fixácia")]), _c('p', [_vm._v("preplatenosť")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-divider"
  }, [_c('div', [_vm._v("8. Prílohy odovzdané Klientovi")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-layout-grid-c grid-iv-columns"
  }, [_c('div', {
    staticClass: "content-block filter-primary"
  }, [_c('img', {
    staticClass: "checkmark",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f4f_icons8-ok.svg",
      "loading": "lazy",
      "alt": ""
    }
  }), _c('div', [_vm._v("Kópia záznamu")])]), _c('div', {
    staticClass: "content-block filter-primary"
  }, [_c('img', {
    staticClass: "checkmark",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f4f_icons8-ok.svg",
      "loading": "lazy",
      "alt": ""
    }
  }), _c('div', [_vm._v("Žiadosť o úver")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-divider"
  }, [_c('div', [_vm._v("9. Ostatné ustanovenia")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "subheading"
  }, [_c('strong', [_vm._v("Právny následok uzatvorenia sprostredkovanej Finančnej služby.")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "subheading"
  }, [_c('strong', [_vm._v("Informácie k rizikám, o ktorých bol klient informovaný")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "subheading"
  }, [_c('strong', [_vm._v("Vyhlásenia Klienta")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "paragraph"
  }, [_vm._v(" Klient potvrdzuje že informáciám porozumel a všetky potrebné informácie mu ako Klientovi boli poskytnuté v dostatočnom časovom predstihu pred konkrétnym rozhodnutím tykajúcim sa Finančnej služby a tieto boli postačujúce k prijatiu rozhodnutia tykajúceho sa Finančnej služby. "), _c('br'), _c('br'), _vm._v("Klient bol oboznámený s rizikami spojenými s odporúčanými i zvolenými Finančnými službami, porozumel im a je schopný tieto riziká zvládnuť. Klient si je vedomý svojej finančnej situácie a finančných záväzkov, ktoré mu budú vyplývať zo sprostredkovanej Finančnej služby a zároveň vyhlasuje, že jeho finančná situácia umožňuje plnenie záväzkov zo zmluvy o poskytovaní Finančnej služby, ktorú si zvolil, bez negatívnych dopadov."), _c('br'), _c('br'), _vm._v("Klient berie na vedomie, že ak neuviedol na stretnutí s Finančným agentom a/alebo nevyplnil niektoré vstupné informácie a ďalšie informácie uvedené tomto zázname podľa § 35 zákona o FSa/alebo § 73f a/alebo § 73g zákona o CP, má sa za to, že takéto informácie poskytnúť odmieta, avšak trvá na uzavretí zmluvy o poskytnutí Finančnej služby, pričom nemusí byť možné správne určiť, či sú odporúčané Finančné služby tohto záznamu pre Klienta vhodné. Klient berie na vedomie, že v situácii podľa predchádzajúcej vety, Finančný agent nenesie zodpovednosť za neprimeranosť rizík a nevhodnosť zvolenej Finančnej služby."), _c('br'), _c('br'), _vm._v("Klient potvrdzuje, že pred vykonaním Finančného sprostredkovania bol informovaný, že finančná služba je odplatná a Finančný agent za ňu dostáva peňažné plnenia vo forme provízií, príspevkov a odmien podľa províznych podmienok SFA a môže prijímať aj nepeňažné plnenie vo forme výhier zo súťaží organizovaných SFA. Bol informovaný o možnosti informovať sa na výšku peňažného resp. nepeňažného plnenia a v prípade požiadavky bol vyčerpávajúcim, zrozumiteľným, presným a jednoznačným spôsobom informovaný o výške. Potvrdzujem, že ma Finančný agent presným a zrozumiteľným spôsobom informoval o všetkých finančných nákladoch súvisiacich so sprostredkovanou Finančnou službou a že mi poskytol informácie o všetkých skutočnostiach nevyhnutných k môjmu rozhodnutiu v zmysle §3 zákona o FS. Klient vyhlasuje, že berie na vedomie, že SFA ani PFA nenesie zodpovednosť za neprimeranosť rizík a nevhodnosť zvolenej Finančnej služby."), _c('br'), _c('br'), _vm._v("Klient vyhlasuje, že tento obchod vykonáva vo vlastnom mene, na vlastný účet, finančné prostriedky použité pri tomto obchode sú jeho vlastníctvom, pochádzajú z jeho vlastných zdrojov, je konečný užívateľ výhod, nie je politicky exponovanou osobou. Vyhlásenie uvedené v predchádzajúcej vete a v definícii pojmov nie sú účinné, ak Klient v časti potreby a požiadavky Klienta vyhlásil opak a tieto skutočnosti boli zaznamenané do príslušnej prílohy stanovenej Smernicou o AML."), _c('br'), _c('br'), _vm._v("Klient potvrdzuje, že Finančný agent si splnil povinnosť zistiť a zaznamenať požiadavky a potreby Klienta, jeho skúsenosti a znalosti týkajúce sa príslušnej Finančnej služby a informácie o jeho finančnej situácii, a to s ohľadom na povahu Finančnej služby, ktorá je predmetom finančného sprostredkovania. ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "subheading"
  }, [_c('strong', [_vm._v("Ochrana osobných údajov")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "subheading"
  }, [_c('strong', [_vm._v("Spôsob a systém ochrany pred zlyhaním Finančnej inštitúcie")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "subheading"
  }, [_c('strong', [_vm._v("Postup pri podávaní sťažností")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "subheading"
  }, [_c('strong', [_vm._v("Ďalšie informácie")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "paragraph"
  }, [_vm._v(" SFA ako samostatný finančný agent spolupracuje s viacerými finančnými inštitúciami na základe nevýhradných zmlúv. Na požiadanie klienta je SFA, respektíve PFA povinný oznámiť Klientovi obchodné mená finančných inštitúcií, s ktorými má SFA uzatvorené zmluvy o Finančnom sprostredkovaní. Obchodné mená spoločností Finančných inštitúcií sú uvedené v registri NBS: https://regfap.nbs.sk/search.php."), _c('br'), _c('br'), _vm._v("Finančný agent neúčtuje Klientom žiadne dodatočné poplatky či náklady, spojené s finančným sprostredkovaním. "), _vm._v(" Znalecký posudok ponúkaný na webovej stránke PFA ("), _c('a', {
    attrs: {
      "href": "http://www.bankari.sk"
    }
  }, [_vm._v("www.bankari.sk")]), _vm._v(") je službou sprostredkovania mimo zákona o finančnom sprostredkovaní a súvisí s realitnou činnosťou PFA pod obchodným názvom osobnimakleri.sk ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "subheading"
  }, [_c('strong', [_vm._v("Majetková prepojenie SFA od 01.04.2022")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "paragraph"
  }, [_vm._v(" SFA nemá kvalifikovanú účasť na základnom imaní alebo hlasovacích právach žiadneho svojho PFA a ani žiadnej Finančnej inštitúcie, s ktorou má uzavretú zmluvu, predmetom ktorej je vykonávanie Finančného sprostredkovania (ďalej „ZoFS“). Žiadna Finančná inštitúcia, s ktorou má SFA uzavretú ZoFS, nemá kvalifikovanú účasť na základnom imaní alebo hlasovacích právach Finančného agenta. NN Continental Europe Holdings B.V. so sídlom: Schenkkade 65, Den Haag, 2595 AS, Holandsko má kvalifikovanú účasť na základom imaní a hlasovacích právach SFA, pričom je zároveň ovládajúcou osobou spoločnosti NN Životná poisťovňa, a.s., Jesenského 4/C, 811 02 Bratislava, IČO: 35 691 999 (ďalej „NN ŽP“ ), spoločnosti NN Tatry – Sympatia, d.d.s., a.s., Jesenského 4/C, 811 02 Bratislava, IČO: 35 976 853 (ďalej „NN DDS“) a spoločnosti NN dôchodková správcovská spoločnosť, a.s., Jesenského 4/C, 811 02 Bratislava, IČO: 35 902 981 (ďalej „NN DSS“). SFA FP má s NN ŽP, NN DDS a NN DSS uzatvorenú ZoFS."), _c('br'), _c('br'), _vm._v("PFA nemá kvalifikovanú účasť na základnom imaní alebo hlasovacích právach SFA. Podľa informácií, ktoré má SFA FP k dispozícii, žiadny PFA nemá kvalifikovanú účasť na základnom imaní ani na hlasovacích právach ktorejkoľvek z Finančných inštitúcii, s ktorými má SFA uzatvorenú ZoFS. Podľa informácií, ktoré má SFA k dispozícii, žiadna finančná Inštitúcia, resp. osoby ovládajúce Finančné inštitúcie, s ktorými má SFA FP uzatvorenú ZoFS, nemá kvalifikovanú účasť na základnom imaní ani na hlasovacích právach ktoréhokoľvek PFA, ktorý je právnickou osobou. ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-divider"
  }, [_c('div', [_vm._v("10. Potvrdenie klienta")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "paragraph"
  }, [_vm._v(" Klient svojim podpisom potvrdzuje správnosť, pravdivosť a úplnosť údajov spracovaných v tomto Zázname, rovnako potvrdzuje, že od Finančného agenta prevzal kópiu tohto záznamu (vrátane príloh). Je si vedomý, že chýbajúce, neúplné, nepravdivé alebo neuvedené údaje môžu viesť k negatívnym dôsledkom pri zostavení ponuky produktu. Na znak súhlasu s uvedenými údajmi a vyhláseniami na všetkých stranách Záznamu Klient tento Záznam podpisuje."), _c('br'), _c('br'), _vm._v("Klient potvrdzuje, že bol informovaný o spôsobe výpočtu poplatku a iných nákladov súvisiacich so sprostredkovanou zmluvou Finančnej služby úveru na bývanie. Klient bol informovaný, že na základe písomnej požiadavky má Finančný agent povinnosť informovať Klienta o rozdieloch vo výškach peňažného plnenia v percentách, ktoré prijíma Finančný agent za Finančné sprostredkovanie od jedného alebo viacerých veriteľov. Informácia v zmysle § 21 ods. 5 písm. b) zákona č. 90/2016 Z.z.: predpokladaná výška peňažného plnenia, ktoré má SFA zaplatiť PFA za sprostredkovanie vyššie uvedených úverov je 1%. _ z výšky sprostredkovaného úveru. ")]);

}]

export { render, staticRenderFns }